import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'wouter'
import { ChevronLeft, Loader2 } from 'lucide-react'

const VENUE_ID = '1a694bd9de9ffb81'
const WIDGET_SCRIPT_URL = 'https://buy.tablelist.com/widgets.umd.js'

export default function NightPage() {
	const [, navigate] = useLocation()
	const containerRef = useRef<HTMLDivElement>(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		if (!containerRef.current) return

		// Create the widget div
		const widgetDiv = document.createElement('div')
		widgetDiv.setAttribute('data-tl-widget', 'event-list')
		widgetDiv.setAttribute('data-theme', 'theme-light')
		widgetDiv.setAttribute('data-venue-id', VENUE_ID)
		widgetDiv.setAttribute('data-primary-color', '#a23aff')
		containerRef.current.appendChild(widgetDiv)

		// Load the Tablelist script
		const script = document.createElement('script')
		script.src = WIDGET_SCRIPT_URL
		script.async = true
		script.onload = () => setIsLoading(false)
		script.onerror = () => setIsLoading(false)
		containerRef.current.appendChild(script)

		return () => {
			if (containerRef.current) {
				containerRef.current.innerHTML = ''
			}
		}
	}, [])

	return (
		<div className="min-h-auto bg-[#18181B]">
			<div className="max-w-5xl mx-auto px-5 pb-8">
				{/* Header */}
				<div
					role="banner"
					className="sticky top-0 z-10 flex items-center gap-3 py-3 bg-[#18181B] backdrop-blur-md"
				>
					<button
						onClick={() => navigate('/reservations')}
						className="h-8 w-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
					>
						<ChevronLeft className="h-[22px] w-[22px] text-[#ffffff]" />
					</button>
					<h1 className="text-[20px] leading-[18px] font-bold font-montserrat tracking-wide text-white">
						VIP Night Pool Cabanas
					</h1>
				</div>

				{/* Widget Container */}
				{isLoading && (
					<div className="flex items-center justify-center py-20">
						<Loader2 className="h-8 w-8 animate-spin text-[#EF4444]" />
					</div>
				)}
				<div ref={containerRef} />
			</div>
		</div>
	)
}
